import { FC, ReactElement, ComponentProps } from 'react';
import { useFragment, graphql } from 'react-relay';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { Button } from 'dibs-elements/exports/Button';

import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';

import { PdpSharedContactSellerButton_item$key } from './__generated__/PdpSharedContactSellerButton_item.graphql';
import { PdpSharedContactSellerButton_user$key } from './__generated__/PdpSharedContactSellerButton_user.graphql';
import { PdpSharedContactSellerButton_viewer$key } from './__generated__/PdpSharedContactSellerButton_viewer.graphql';

const viewerFragment = graphql`
    fragment PdpSharedContactSellerButton_viewer on Viewer {
        ...SharedContactDealerWrapper_viewer
    }
`;

const userFragment = graphql`
    fragment PdpSharedContactSellerButton_user on User {
        ...SharedContactDealerWrapper_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedContactSellerButton_item on Item {
        ...SharedContactDealerWrapper_item
    }
`;

type ButtonProps = ComponentProps<typeof Button>;

export const PdpSharedContactSellerButton: FC<{
    children: ReactElement;
    dataTn?: string;
    item: PdpSharedContactSellerButton_item$key;
    user: PdpSharedContactSellerButton_user$key;
    viewer: PdpSharedContactSellerButton_viewer$key;
    type?: ButtonProps['type'];
    size?: ButtonProps['size'];
    launchOrigin?: string;
    fullWidth?: boolean;
    className?: string;
}> = ({ children, dataTn, type, size, launchOrigin, fullWidth, className, ...props }) => {
    const viewer = useFragment(viewerFragment, props.viewer);
    const user = useFragment(userFragment, props.user);
    const item = useFragment(itemFragment, props.item);

    return (
        <CurrencyProvider
            render={({ currency }: $TSFixMe) => (
                <SharedContactDealerWrapper
                    launchOrigin={launchOrigin}
                    item={item}
                    user={user}
                    viewer={viewer}
                    currency={currency}
                >
                    {(onClick: $TSFixMe) => (
                        <Button
                            fullWidth={fullWidth}
                            type={type}
                            size={size}
                            dataTn={dataTn}
                            onClick={onClick}
                            className={className}
                        >
                            {children}
                        </Button>
                    )}
                </SharedContactDealerWrapper>
            )}
        />
    );
};

export default PdpSharedContactSellerButton;
